var $dd4c0ba707e5f0c8$exports = {};
// logga ut-knapp
const $dd4c0ba707e5f0c8$var$logOutBtnEl = document.getElementById("logoutbtn");
$dd4c0ba707e5f0c8$var$logOutBtnEl.addEventListener("click", $dd4c0ba707e5f0c8$var$logout);
function $dd4c0ba707e5f0c8$var$logout() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    window.location.href = "index.html";
}
const $dd4c0ba707e5f0c8$var$url = "https://pizzaapi-kzs1.onrender.com/message" //URL till mitt API
;
/* Hämta bokningarna */ window.onload = $dd4c0ba707e5f0c8$var$init;
async function $dd4c0ba707e5f0c8$var$init() {
    const token = localStorage.getItem("token");
    const response = await fetch($dd4c0ba707e5f0c8$var$url, {
        headers: {
            "Authorization": "Bearer " + token
        }
    });
    const data = await response.json();
    console.log(data);
    $dd4c0ba707e5f0c8$var$displayMessages(data);
}
//skriv ut meddelandena
function $dd4c0ba707e5f0c8$var$displayMessages(data) {
    const messageListEl = document.getElementById("messageList");
    data.forEach((e)=>{
        const messageItem = document.createElement("div");
        messageItem.classList = "messageItem";
        messageItem.innerHTML += `<h4 class="name">Namn: ${e.name}</h4>
        <p class="email">Email: ${e.email}</p>
        <p class="message">Meddelande: ${e.message}</p> 
        <p class="created">Skapad: ${e.created}</p> 
        </div>`;
        const deleteMessageBtn = document.createElement("input");
        deleteMessageBtn.type = "button";
        deleteMessageBtn.classList = "deleteBtn button";
        deleteMessageBtn.value = "Radera meddelande";
        deleteMessageBtn.addEventListener("click", ()=>{
            $dd4c0ba707e5f0c8$var$deleteMessage(e._id);
        });
        messageListEl.appendChild(messageItem);
        messageItem.appendChild(deleteMessageBtn);
    });
}
//radera meddelandena
async function $dd4c0ba707e5f0c8$var$deleteMessage(id) {
    const token = localStorage.getItem("token");
    const response = await fetch($dd4c0ba707e5f0c8$var$url + "/" + id, {
        method: "DELETE",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "Application/json"
        }
    });
    const data = await response.json();
    console.log(data);
    if (data.error) ;
    else /* status.innerHTML = `${data.message}`; */ location.reload();
}


//# sourceMappingURL=admin-messages.c3680aa3.js.map
